// ** Store Import
import { store } from "../../../../redux/store"

// ** Action Imports
import {
  setVerificationCodesInputModalData,
  setVerificationCodesInputModalOpen
} from "./redux/verificationCodesInputModalSlice"

export const showVerificationCodesInputModal = ({
  onOpen = () => {},
  onClose = () => {},
  title = "Verify OTP Code", // modal title
  email = false,
  initialEmailTimer = null, // Inital countdown timer
  sms = false,
  initialSMSTimer = null, // Inital countdown timer
  otp = false,
  showEmailResendCode = true,
  showSMSResendCode = true,
  handleEmailResendCode = () => {},
  handleSMSResendCode = () => {},
  callback = () => {},
  errCallback = () => {}
}) => {
  // console.log(handleEmailResendCode)
  store.dispatch(
    setVerificationCodesInputModalData({
      onOpen,
      onClose,
      title,
      email,
      initialEmailTimer,
      sms,
      initialSMSTimer,
      otp,
      showEmailResendCode,
      showSMSResendCode,
      handleEmailResendCode,
      handleSMSResendCode,
      callback,
      errCallback
    })
  )
  store.dispatch(setVerificationCodesInputModalOpen(true))
}

export const hideVerificationCodesInputModal = () => {
  store.dispatch(setVerificationCodesInputModalOpen(false))
  store.dispatch(
    setVerificationCodesInputModalData({
      onOpen: () => {},
      onClose: () => {},
      title: "Verify OTP Code",
      email: false,
      initialEmailTimer: null,
      sms: false,
      initialSMSTimer: null,
      otp: false,
      showEmailResendCode: true,
      showSMSResendCode: true,
      handleEmailResendCode: () => {},
      handleSMSResendCode: () => {},
      callback: () => {},
      errCallback: () => {}
    })
  )
}
